import { render } from "./UpcomingMatches.vue?vue&type=template&id=048dcb4e&scoped=true"
import script from "./UpcomingMatches.vue?vue&type=script&lang=js"
export * from "./UpcomingMatches.vue?vue&type=script&lang=js"

import "./UpcomingMatches.vue?vue&type=style&index=0&id=048dcb4e&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048dcb4e"]])

export default __exports__